import React, { useEffect, useState } from 'react';
import { lightGreen, red } from '@mui/material/colors';
import { styled } from '@mui/material/styles';

import { useLayout } from '../../context/LayoutContext';
import { toast } from 'react-toastify';

import {
  Box,
  CircularProgress,
  Typography,
  Grid,
  Checkbox,
} from '@mui/material';
import { DataGrid,GridToolbar, gridClasses,GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';

import {
  useGetShiftsQuery,
  useAssignShiftToUserMutation,
} from '../../slices/shiftApiSlice';

import {
  useGetAgenciesQuery,
} from '../../slices/agencyApiSlice';
import { useAssignShiftToAgencyMutation } from '../../slices/shiftApiSlice';
import { useUpdateShiftRequestStatusMutation } from '../../slices/shiftRequestApiSlice';


import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
  Button,
  TextField, // <-- ADD THIS
} from '@mui/material';
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  
} from '@mui/material';



import {
  useGetShiftRequestsByShiftIdQuery,
} from '../../slices/shiftRequestApiSlice';



// Styled DataGrid with conditional row styles
const StyledDataGrid = styled(DataGrid)`
  & .${gridClasses.row}.lightGreenRow {
    background-color: ${lightGreen[100]};
  }
  & .${gridClasses.row}.redRow {
    background-color: ${red[100]};
  }
     & .${gridClasses.row}.lightOrangeRow {
    background-color: #ffe0b2; /* Light orange */
  }
  & .${gridClasses.row}.greenRow {
    background-color: #c8e6c9; /* Soft green */
  }

  & .${gridClasses.row}.darkGreenRow {
    background-color:rgb(149, 240, 152); /* Dark green */
  }

`;

const ShiftApproveScreen = () => {
  const { setFluid } = useLayout();
const CustomToolbar = () => (
  <div style={{ padding: '0.5rem 1rem' }}>
    <GridToolbarQuickFilter />
  </div>
);

const [updateShiftRequestStatus] = useUpdateShiftRequestStatusMutation();
  const { userInfo } = useSelector((state) => state.auth);
  const { data: shifts, isLoading: loadingShifts, refetch: refetchShifts } = useGetShiftsQuery();
  const [selectedShiftId, setSelectedShiftId] = useState(null);
const [assignShiftToAgency] = useAssignShiftToAgencyMutation();

const [openConfirmModal, setOpenConfirmModal] = useState(false);
const [selectedShift, setSelectedShift] = useState(null);
const [selectedFiller, setSelectedFiller] = useState(null); // staff or agency object
const [isAgencyFilling, setIsAgencyFilling] = useState(false);
const [selectedShiftRow, setSelectedShiftRow] = useState(null);

const [filledByName, setFilledByName] = useState('');
const [filledByAgencyWorkerContact, setFilledByAgencyWorkerContact] = useState('');


//__________________________________________________________________________________________________________________________________________________


const handleConfirmAssignment = async () => {
  try {
    if (!selectedShift || !selectedFiller) {
      toast.error('Please select both a shift and a filler');
      return;
    }



    if (isAgencyFilling) {
      // Call the agency assignment function
       if (!filledByName.trim() || !filledByAgencyWorkerContact.trim()) {
    alert('Please fill in both agency worker name and contact details before proceeding.');
    return;
  }
      await handleAgencyApprove(selectedFiller);
    } else {
      // Construct a fake request object to match handleApprove signature
      const request = {
        requestedBy: selectedFiller._id,
        requestedByName: selectedFiller.requestedByName,
        requestedByEmail: selectedFiller.requestedByEmail,
        requestId: selectedFiller._id,
        lineStatus: 'Approved',
      };
      await handleApprove(request);
    }

    setOpenConfirmModal(false);
    setSelectedShift(null);
    setSelectedFiller(null);
    setFilledByName('');
setFilledByAgencyWorkerContact('');

    toast.success('Shift successfully assigned!');
  } catch (error) {
    console.error('Assignment failed:', error);
    toast.error('Failed to assign shift');
  }
};

//__________________________________________________________________________________________________________________________________________________


const handleAssignClick = (shift, filler, isAgency = false) => {
  setSelectedShift(shift);
  setSelectedFiller(filler);
 //console.log("in handleAssignClick ..filler..... ", filler)
 //console.log("in handleAssignClick .shift...... ", shift)
 //console.log("in handleAssignClick ..filler..... ", filler.requestedByName)
 //console.log("in handleAssignClick .isAgency...... ", isAgency)

 
  // Option 3: For more complex logic
if (filler.requestType === 'Agency' || isAgency ) {
  setIsAgencyFilling(true); // agency request
} else {
  setIsAgencyFilling(false); // staff or other request
}

console.log("in handleAssignClick .IsAgencyFilling...... ", isAgencyFilling)

//  setIsAgencyFilling(isAgency);
  setOpenConfirmModal(true);
};


  const {
    data: shiftRequests,
    refetch,
    isLoading: loadingRequests,
  } = useGetShiftRequestsByShiftIdQuery(selectedShiftId, {
    skip: !selectedShiftId,
  });

   const { data: agencies, isLoading: loadingAgencies } = useGetAgenciesQuery();


  const [assignShift] = useAssignShiftToUserMutation();


  //__________________________________________________________________________________________________________________________________________________


  const handleAgencyApprove = async (agency) => {
  try {
   //console.log('Assigning to agency:', agency);

    await assignShiftToAgency({
      shiftId: selectedShiftId,
      agencyId: agency._id,
      agencyName: agency.agencyName,
      agencyEmail: agency.agencyEmail,
      managerId: userInfo._id,
      lineStatus: 'FilledByAgency',
      filledByName, // 🆕
  filledByAgencyWorkerContact, // 🆕
    }).unwrap();

    refetch(); // To reload shiftRequest data
    refetchShifts() // To reload shift data
  } catch (err) {
    console.error('Failed to assign shift to agency:', err);
  }
};


  

  useEffect(() => {
  if (selectedShiftId) {
    refetch();
  }
}, [selectedShiftId]);

  useEffect(() => {
   //console.log('Fetched shiftRequests:', shiftRequests);
    
  }, [shiftRequests]);

  useEffect(() => {
    // Enable full-width container
    setFluid(true);

    return () => {
      // Reset back to normal when screen unmounts
      setFluid(false);
    };
  }, [setFluid]);

  //const handleApprove = async (userId) => {

    //__________________________________________________________________________________________________________________________________________________


    const handleApprove = async (request) => {
    try {
 //console.log('approve codes. selectedShiftId:', selectedShiftId);
 //console.log('approve codes. userId:', request.requestedBy);
 //console.log('approve codes. requestId:',  request.requestId);
 //console.log('approve codes. userInfo._id:', userInfo._id);

  await assignShift({
    shiftId: selectedShiftId,
    userId: request.requestedBy,
    userName: request.requestedByName,
    userEmail: request.requestedByEmail,
    managerId: userInfo._id,
    lineStatus: 'FilledByStaff',
  }).unwrap();

  // 2. Update their shift request's status to 'Approved'

   //await updateShiftRequestStatus(request).unwrap();

     await updateShiftRequestStatus({
       shiftRequestId: request.requestId,     // <-- Ensure this field exists in `request`
       lineStatus: 'Approved',
     }).unwrap();

  await refetch();
  await refetchShifts(); // ✅ refresh the main list
} catch (err) {
  console.error('Failed to assign shift:', err);
}
  };

  

  //__________________________________________________________________________________________________________________________________________________



  const agencyColumns = [
 {
  field: 'assign',
  headerName: 'Assign',
  width: 120,
  renderCell: (params) => (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      disabled={!selectedShiftRow}
      onClick={async () => {
  await handleAssignClick(selectedShiftRow, params.row, true);
  //await handleAgencyApprove(selectedShiftRow._id, params.row._id);
}}

    >
      Assign
    </Button>
  ),
},

  { field: 'agencyName', headerName: 'Agency Name', width: 160 },
  { field: 'agencyEmail', headerName: 'Agency Email', width: 200 },
  { field: 'agencyPhone', headerName: 'Phone', width: 140 },
  { field: 'agencyTier', headerName: 'Tier', width: 100 },
];

//__________________________________________________________________________________________________________________________________________________

  const shiftColumns = [
    {
  field: 'select',
  headerName: 'Select',
  width: 120,
  renderCell: (params) => (
    <Button
      variant="contained"
      color="primary"
      size="small"
      disabled={!selectedShiftRow}
      

      onClick={async () => {
       
 // await handleAssignClick(selectedShiftRow, params.row, false);
  //await handleApprove(selectedShiftRow._id, params.row._id);
}}
    >
      Select
    </Button>
  ),
},

    {
      field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
      valueGetter: (params) => new Date(params.row.startDateTime).toLocaleString(),
    },
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
      valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
    },
    { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 180 },
    { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
    { field: 'lineStatus', headerName: 'Line Status', width: 120 },
    
    
  ];
//{ field: 'filledByName', headerName: 'Staff Name', width: 150 },

//__________________________________________________________________________________________________________________________________________________


  const requestColumns = [
   {
  field: 'assign',
  headerName: 'Assign',
  width: 120,
  renderCell: (params) => (
    <Button
      variant="contained"
      //color="primary"
      color="secondary"
      size="small"
      disabled={!selectedShiftRow}
      onClick={() => {
        
        handleAssignClick(selectedShiftRow, params.row, false);
        //handleApprove(selectedShiftRow._id, params.row._id); // shiftId, staffId
      }}
    >
      Assign
    </Button>
  ),
},
    { field: 'requestedByName', headerName: 'Name', width: 160 },
    { field: 'requestedByEmail', headerName: 'Email', width: 200 },
    
     /* {field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
      valueGetter: (params) => new Date(params.row.startDateTime).toLocaleString(),
    },
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
      valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
    },
*/
  ];

//__________________________________________________________________________________________________________________________________________________

  const getRowClassName = (params) => {
    
  const now = new Date();
  const end = new Date(params.row.endDateTime);

  if (end < now) return 'redRow';

  const status = params.row.lineStatus?.toLowerCase();

  switch (status) {
    case 'open':
    case 'on hold':
      return 'lightOrangeRow';

    case 'archived':
    case 'filledbystaff':
    
    case 'filled':
    case 'complete':
      return 'greenRow';

      case 'filledbyagency':
return 'darkGreenRow';


    case 'cancelled':
      return 'redRow';

     

    default:
      return 'lightGreenRow';
  }
};

//______________________________________________________________________________________________________________________________________________
  //<Box sx={{ p: 2 }}>
  return (
    
      <Box sx={{ p: 1, maxWidth: '100%' }}>
      <Typography variant="h4" mb={2}>
        Shift Approval Panel
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={2}>
        Selected Shift ID: {selectedShiftId || 'None'}
      </Typography>


      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          
          {loadingShifts ? (
            <CircularProgress />
          ) : (

            
     <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader title=" Shifts Awaiting Approval" />
      <CardContent>


            <StyledDataGrid
            density="compact"
  rows={shifts?.filter((s) => !s.stage1Approval) || []}
  columns={shiftColumns}
  getRowId={(row) => row._id}
  autoHeight
  pageSize={10}
  getRowClassName={getRowClassName}
  onRowClick={(params) => {
    setSelectedShiftId(params.row._id);
    setSelectedShiftRow(params.row);
  }}
  slots={{ toolbar: GridToolbar }}
  slotProps={{ toolbar: { showQuickFilter: true } }}
  sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
/>
</CardContent>
   </Card>                    

          )}
        </Grid>



        <Grid item xs={12} md={3}>
          
          {loadingRequests ? (
            <CircularProgress />
          ) : (

            <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader title=" Staff Requests" />
      <CardContent>

            <StyledDataGrid
  density="compact"
  rows={shiftRequests?.length ? shiftRequests : []}
  columns={requestColumns}
  getRowId={(row) => row._id}
  autoHeight
  pageSize={10}
  getRowClassName={(params) =>
    params.indexRelativeToCurrentPage % 2 === 0 ? 'lightGreenRow' : 'darkGreenRow'
  }
  slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
  sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
/>
</CardContent>
</Card>
          )}
        </Grid>







         <Grid item xs={12} md={4}>
    
    {loadingAgencies ? (
      <CircularProgress />
    ) : (
       <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader title=" Agencies" />
      <CardContent>

      <DataGrid
      density="compact"
        
         rows={
    (agencies || [])
      .slice() // Make a shallow copy so original data isn't mutated
      .sort((a, b) => {
        // First, sort by agencyTier (e.g., Tier1 < Tier2 < Tier3 < Tier4)
        const tierOrder = ['Tier1', 'Tier2', 'Tier3', 'Tier4'];
        const tierComparison =
          tierOrder.indexOf(a.agencyTier) - tierOrder.indexOf(b.agencyTier);

        if (tierComparison !== 0) return tierComparison;

        // Then, sort alphabetically by agencyName
        return a.agencyName.localeCompare(b.agencyName);
      })
  }

        columns={agencyColumns}
        getRowId={(row) => row._id}
        autoHeight
        pageSize={10}
         getRowClassName={(params) => {
    switch (params.row.agencyTier) {
      case 'Tier1': return 'tier1';
      case 'Tier2': return 'tier2';
      case 'Tier3': return 'tier3';
      case 'Tier4': return 'tier4';
      default: return '';
    }}}

     slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
  
      />
      </CardContent>
      </Card  >
    )}
  </Grid>

      </Grid>




      <Dialog open={openConfirmModal} onClose={() => setOpenConfirmModal(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Confirm Shift Assignment</DialogTitle>
  <DialogContent>
    {selectedShift && (
      <Box>
        <Typography variant="subtitle1" gutterBottom><strong>Shift Details</strong></Typography>
        <Typography>Location: {selectedShift.hospitalLocationId?.name}</Typography>
        <Typography>Ward: {selectedShift.wardDepartmentArea}</Typography>
        <Typography>Start: {new Date(selectedShift.startDateTime).toLocaleString()}</Typography>
        <Typography>End: {new Date(selectedShift.endDateTime).toLocaleString()}</Typography>

        <Divider sx={{ my: 2 }} />



<Typography variant="subtitle1" gutterBottom>
  <strong>{isAgencyFilling ? 'Agency' : 'Staff'} Details</strong>
</Typography>

{isAgencyFilling ? (
  <>
    <Typography>Name: {selectedFiller?.agencyName}</Typography>
    <Typography>Email: {selectedFiller?.agencyEmail}</Typography>
    <Typography>Tier: {selectedFiller?.agencyTier}</Typography>

     <TextField
      fullWidth
      label="Agency Worker Name"
      value={filledByName}
      onChange={(e) => setFilledByName(e.target.value)}
      margin="normal"
    />
    <TextField
      fullWidth
      label="Agency Worker Contact"
      value={filledByAgencyWorkerContact}
      onChange={(e) => setFilledByAgencyWorkerContact(e.target.value)}
      margin="normal"
    />

  </>
) : (
  <>
    <Typography>Name: {selectedFiller?.requestedByName}</Typography>
    <Typography>Email: {selectedFiller?.requestedByEmail}</Typography>
  </>
)}


      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenConfirmModal(false)}>Cancel</Button>
    <Button 
      onClick={handleConfirmAssignment} 
      color="primary" 
      variant="contained"
    >
      Confirm Assignment
    </Button>
  </DialogActions>
</Dialog>

    </Box>

    
  );
};

/* {
                        _id: 'dummy1',
                        requestedBy: 'user123',
                        requestedByName: 'Test User',
                        requestedByEmail: 'test@example.com',
                        startDateTime: new Date(),
                        endDateTime: new Date(),
                      }, */
export default ShiftApproveScreen;
